// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Avatar from '@mui/material/Avatar'
import Badge from '@mui/material/Badge'

// ** Icons Imports
import MenuIcon from 'mdi-material-ui/Menu'
import Magnify from 'mdi-material-ui/Magnify'
import BellOutline from 'mdi-material-ui/BellOutline'
import { usePageTitle } from 'src/context/PageTitleContext'
import beemzRound from "src/assets/images/beemz-round.png"

// ** Components
// import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'

const AppBarContent = props => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props

  const { title } = usePageTitle();

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2, px: 3 }}>
      {/* Left: Title */}
      <Typography
        variant='h6'
        sx={{ fontWeight: 700, textTransform: 'none', letterSpacing: 0, mr: 4 }}
      >
        {title}
      </Typography>

      {/* Center: Search */}
      <Paper
        component="form"
        sx={{
          p: '2px 8px',
          display: 'flex',
          alignItems: 'center',
          width: 260,
          backgroundColor: '#FAFAFC',
          boxShadow: 'none',
          borderRadius: 2,
          mr: 2
        }}
        elevation={0}
      >
        <Magnify sx={{ color: 'text.primary', mr: 1 }} />
        <InputBase
          sx={{ ml: 1, flex: 1, fontSize: 16 }}
          placeholder="search"
          inputProps={{ 'aria-label': 'search' }}
        />
      </Paper>

      {/* Right: Notification + User */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Badge
          variant="dot"
          color="secondary"
          overlap="circular"
          sx={{ mr: 2 }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <IconButton>
            <BellOutline />
          </IconButton>
        </Badge>
        {/* User section */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            alt="finance admin"
            src={beemzRound}
            sx={{ width: 40, height: 40, mr: 1.5 }}
          />
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: 16, lineHeight: 1 }}>
              finance admin
            </Typography>
            <Typography sx={{ fontSize: 13, color: 'text.secondary', lineHeight: 1 }}>
              financeadmin@beemz.com
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AppBarContent